export default "__VITE_ASSET__Dbx52K60__"